/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

const jsonData = {
  "squareup": {
    "nested": {
      "banklin": {
        "nested": {
          "StoredValueBalance": {
            "nested": {
              "Type": {
                "values": {
                  "CURRENCY": 1,
                  "EQUITY": 2,
                  "SAVINGS": 3,
                  "LOAN": 4,
                  "INVEST_PAYMENT": 5,
                  "GIFT_CARD": 6,
                  "CCY_CLEARING": 7,
                  "EXT_INSTRUMENT": 8,
                  "OVERDRAFT": 9,
                  "P2P": 10,
                  "EXCHANGE": 11,
                  "FUNDING_PROMISE": 12,
                  "AFTERPAY_LOAN": 13,
                  "MONEY_POOL": 14
                }
              }
            }
          }
        }
      }
    }
  }
}

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.banklin?.nested?.StoredValueBalance?.nested?.Type) {
	$root.addJSON(jsonData);
}

/**
 * SOURCE StoredValueBalance @ squareup/banklin/stored_value_balance.proto at 9:1
 */
export const StoredValueBalance = {};
/**
 * SOURCE Type @ squareup/banklin/stored_value_balance.proto at 34:3
 */
StoredValueBalance.Type = $root.lookupEnum('squareup.banklin.StoredValueBalance.Type').values;
